import {Component, Input} from '@angular/core';
/**
 * A component that renders an SVG icon for "Lock-Closed-Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-lock-closed-outline',
    templateUrl: './icon-lock-closed-outline.component.html',
    styleUrls: ['./icon-lock-closed-outline.component.scss'],
    standalone: false
})
export class IconLockClosedOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
